import ChanDoanPTTT from "./ChanDoanPTTT";
import LuocDoPTTTField from "./LuocDoPTTTField";

interface Props {
  data: any;
}

const CustomComponent = ({ data }: Props) => {

  const Default = () => {
    return <></>;
  };

  const components: { [key: string]: any } = {
    chanDoanPTTT: ChanDoanPTTT,
    luocDoPTTT: LuocDoPTTTField
  };

  const DynamicContent = components[data?.componentName] || Default;

  return <DynamicContent {...data} />;
};

export default CustomComponent;
